<template>
  <div>
    <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId" noAbout="noAbout"></topIcon>
    <van-loading type="spinner" v-if="nodata"/>
    <div>
      <div class="logo" :class="[`${dominItem.templateId}`, `${dominItem.templateId}1`]">
        {{ dominItem.logoName || 'Logo' }}
      </div>
      <div class="category" :class="`${dominItem.templateId}`">
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
      </div>
    </div>
    <div style="padding: 0 10%;">
      <div class="news-page-container">
        <div class="left-column">
          <h2 class="section-title">{{ $t('con_recommended') }}</h2>
          <article class="news-item" v-for="(item, index) in articleList" @click="toDetail(item.articleShortName)">
            <h3 class="news-title threeHde">{{ item.articleTitle }}</h3>
            <p class="news-desc foreHde">{{ item.articleIntro }}</p>
<!--            <hr v-if="index !== businessNews.length - 1" />-->
          </article>
        </div>
        <div  style="display: flex; flex-direction: column; width: 600px">
        <div class="center-column" v-for="item in articleList1" @click="toDetail(item.articleShortName)">
          <img
              :src="item?.articleImage"
              class="main-image"
          />
          <p class="image-caption foreHde" style="margin-left: 0">
            {{ item.articleTitle }}
          </p>
          <h1 class="main-title threeHde" style="margin-left: 0">
            {{ item.articleIntro }}
          </h1>
        </div>
        </div>
        <div class="right-column">
          <h2 class="section-title">{{ $t('con_hot_con') }}</h2>
          <article class="news-item" v-for="(item, index) in articleList2" @click="toDetail(item.articleShortName)">
            <img :src="item?.articleImage" alt="">
            <h3 class="news-title threeHde">{{ item.articleTitle }}</h3>
            <p class="news-desc foreHde">{{ item.articleIntro }}</p>
<!--            <hr v-if="index !== publicInterestNews.length - 1" />-->
          </article>
        </div>
      </div>

      <div class="news-page">

        <!-- 中间内容 -->
        <div class="middle-column">
          <section class="news-section" v-for="item in articleList3" @click="toDetail(item.articleShortName)">
            <article class="news-item" style="border: none; margin-bottom: 0">
              <h3 class="news-title twoHde" style="margin-left: 0; margin-bottom: 10px">
                {{ item.articleTitle }}</h3>
              <p class="news-desc threeHde" style="margin-left: 0; margin-bottom: 20px">
                {{ item.articleIntro }}
              </p>
              <img
                  :src="item?.articleImage"
                  class="news-image"
              />

<!--              <p class="news-author">{{ item.uploadTime }}</p>-->
            </article>
          </section>
        </div>

        <!-- 右侧内容 -->
        <div class="right-column">

          <section class="newsroom-section">
            <h2 class="section-title">{{ $t('con_latest') }}</h2>
            <ul class="newsroom-list">
              <li class="newsroom-item" v-for="item in articleList4" @click="toDetail(item.articleShortName)">
                <img
                    :src="item?.articleImage"
                    class="newsroom-image"
                />
                <div style="display: flex;flex-direction: column">
                <p class="newsroom-title twoHde" style="margin-left: 0">{{ item.articleTitle }}</p>
<!--                <p class="newsroom-author">{{ item.uploadTime }}</p>-->
                </div>
              </li>

            </ul>
          </section>
        </div>
      </div>
    </div>
    <div class="buttom">
      <div class="explore">
        <span style="color: #000000">{{ $t('con_Explore') }}</span>
        <span v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer; color: #000000">{{ item.label }}</span>
      </div>
        <div class="logo" style="color: #000000;">{{ dominItem.logoName || 'Logo' }}</div>
      <footers is00="is00" :articleListlast="articleListlast" :current="current"></footers>
    </div>
  </div>
</template>

<script>
import {getContentList, getLatestNews, getRecommend, getOne, getDomainName, newContent} from "@/api"
import topIcon from '../../icons/small.vue'
import {format} from "date-fns";
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"

export default {
  components: {topIcon, buttomIcon, footers},


  props: {
    dominItem: Object
  },

  name: "index",
  data() {
    return {
      bestItem: {},
      nodata: false,
      // template: 'temp3',
      current: 1,
      recommendList:[],
      latestNewsList:[],
      articleList:[],
      articleList1: [],
      articleList2: [],
      articleList3: [],
      articleList4: [],
      articleListlast:[],
      recommendList1: [],
      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_about'), id: 8},
      ],
      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
    }
  },
  created() {
    this.nationId = JSON.parse(localStorage.getItem('dominItem')).nationId


    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    }else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    }
  },

  methods: {
    openLink(link) {
      window.open(link)
    },
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    },

    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        if (!res.data.articleImage) {
          res.data.articleImage = require('@/assets/defore.jpg')
        }
        this.bestItem = res.data
        // this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },


    // 获取推荐文章列表
    getArticleList() {
      newContent({articleCategoryId: this.current,pageNum: this.newsPageNum, pageSize: 10, articleNationId: this.nationId, articleType: 'con_recommended'}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows

        // this.articleList.map(r => {
        //   // r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
        // })
        this.nodata = false
      })
    },


    // 获取最新文章
    getLatestNewsList() {
      newContent({articleCategoryId: this.current, pageNum: this.newsPageNum, pageSize: 3, articleNationId: this.nationId,  articleType: 'con_latest'}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList1 = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取热门文章
    getRecommendList() {
      newContent({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 5,

        articleNationId: this.nationId, articleType: 'con_hot_con'}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
          this.articleList2 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList1() {
      newContent({articleCategoryId: this.current, pageNum: 1, pageSize: 2, articleNationId: this.nationId, articleType: 'con_bestnew'}).then(res => {
        res.rows.map(r=>{
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList3 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList2() {
      newContent({articleCategoryId: this.current, pageNum: 1, pageSize: 8, articleNationId: this.nationId, articleType: 'con_bestnew'}).then(res => {
        res.rows.map(r=>{
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList4 = res.rows
      })
    },

    // 获取最下面文章列表  相关文章
    getArticleListlast() {
      // this.nodata = true
      newContent({articleCategoryId: this.current,pageNum: 3, pageSize: 6, articleNationId: this.nationId,  articleType: 'con_related'}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">
.news-page-container {
  display: flex;
  //max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.left-column,
.right-column {
  flex: 1;
  padding: 0 15px;
}

.center-column {
  flex: 2;
  padding: 0 15px;
}

.section-title {
  color: #333;
  font-size: 18px !important;
  border-bottom: 2px solid #000;
  padding-bottom: 5px;
  margin-bottom: 15px;
}

.news-item {
  margin-bottom: 20px;
  border-bottom: 1px solid #000000;
  padding-bottom: 10px;

  img {
    width: 100%;
    height: 150px;
    margin-bottom: 10px;
    object-fit: cover;
  }
}

.news-title {
  font-size: 16px;
  margin-left: 0;
}

.news-author {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 5px;
}

.news-desc {
  font-size: 14px;
  margin-left: 0;
  color: #777777;
  line-height: 1.4;
}

.main-image {
  width: 100%;
  height: 400px;
  object-fit: cover;
  margin-bottom: 10px;
}

.image-caption {
  font-size: 14px;
  color: #666;
  margin-bottom: 15px;
}

.article-meta {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 15px;
}

.main-title {
  font-size: 20px;
  margin-bottom: 20px;
}

.news-page {
  display: flex;
  gap: 20px;
  //max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.top-section {
  grid-column: 1 / 4;
}

.ad-image {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
}

.stocks {
  display: flex;
  gap: 10px;
  font-size: 0.9rem;
}

.stock-item {
  color: #333;
}

.left-column,
.middle-column,
.right-column {
  width: 550px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}


.news-image {
  width: 100%;
  height: 200px !important;
  object-fit: cover;
  margin-bottom: 5px;
}


.weather-section {
  margin-bottom: 20px;
}

.weather-card {
  background-color: #f5f5f5;
  padding: 15px;
  text-align: center;
}

.city {
  font-size: 1.1rem;
  margin-bottom: 5px;
}

.temp {
  font-size: 2rem;
  margin-bottom: 5px;
}

.conditions {
  margin-bottom: 5px;
}

.details {
  font-size: 0.8rem;
  margin-bottom: 10px;
}

.forecast {
  display: flex;
  justify-content: space-around;
  font-size: 0.8rem;
}

.newsroom-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.tab-button {
  background-color: #eee;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
}

.tab-button:hover {
  background-color: #ddd;
}

.newsroom-list {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.newsroom-item {
  display: flex;
  gap: 10px;
}

.newsroom-image {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}

.newsroom-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 3px;
}

.newsroom-author {
  font-size: 13px;
  color: #666;
}


.logo {
  width: 100%;
  padding: 20px 20px 10px 10%;
  display: flex;
  box-sizing: border-box;
  font-size: 40px;
  color:#000000;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  text-align: left;
}

.logo-temp1 {
  padding: 0 20px 0 10%;
}

.logo-temp2 {
}

.category {
  width: 100%;
  padding: 10px 10%;
  min-height: 40px;
  margin-bottom: 30px;
  color: #000000;
  border-top: 2px solid #000000;
  border-bottom: 2px solid #000000;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid var(--themeColor);
  line-height: 38px;

  span {
    font-weight: 500;
    font-size: 18px;
    display: inline-block;
    padding: 0 20px;
    cursor: pointer;
    position: relative;
  }

  span:hover {
    color: #FC625C;
    background: #EEEEEE;
    transition: all .1s ease;
  }

  .choose {
    transition: all .1s ease;
    color:#FC625C;;
  }
}

.buttom {
  background: #ffffff;
  border-top: 2px solid #000000;
  display: flex;
  flex-direction: column;

  .logo {
    width: 80%;
    margin:  auto;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
  }

  display: flex;

  .explore {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    align-items: center;

    span:first-child {
      color: #004F8B;
      font-size: 18px;
      font-weight: bold;
      margin-right: 30px;
    }

    span {
      margin-right: 10px;
      font-size: 15px;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #000000;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  padding: 0 10% 20px;
  display: flex;
  flex-wrap: wrap;
  span{
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.imgsss {
  width: 30px;
  height: 30px;
}

.imgsss:nth-child(4){
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(5){
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(6){
  width: 40px;
  height: 40px;
}

.article-image1 {
  width: 80px;
  height: 80px;
  object-fit: cover;
}

</style>
